export { default } from './RulesPage';
